import { render, staticRenderFns } from "./customerStockPriceGroupList.vue?vue&type=template&id=27a71c08&"
import script from "./customerStockPriceGroupList.vue?vue&type=script&lang=js&"
export * from "./customerStockPriceGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports